import Vue from "vue";
import {
  API_ROOT,
  API_ROOT_V2,
  API_ROOT_V3,
  API_ROOT_STUDY_RESPONSE,
  COGNITO_API_US_WEB_ROOT,
  participantManagement,
  participants,
  importcsv,
  exportcsv,
  downloadtemplate,
  invite,
  search,
  verify,
  studies,
  resetPassword,
  sortparticipants,
  customlabels,
  customlabel,
  documents,
  requestsignature,
  eventhistory,
  piesignature,
  maildocument,
  userdefinedParticipantId,
  email,
  pagination,
  notInvited,
  multi,
  pushnotification,
  resetPasswordContent,
  responsemanagement,
  edc,
  studyManagement,
  users,
  blinded,
  resendVerify,
  site,
  team,
  participant,
  queryTool,
  tasks,
  study,
  milestones,
  milestone,
  completed,
  start,
  sites,
  document,
  notifications,
  notification,
  send,
  sent,
  unsubscribeemail,
  participantlist,
  demand,
  activity,
  version,
  signoff,
  transfer,
  prescreened,
  status,
  statusKey,
  studyResponse,
  general,
  updateCognitoPhoneNumber,
  ESIGN_API_WEB_ROOT,
  orderStatus
} from "./urls";

const participantsResource = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}/${participants}{/participantId}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const participantsResourceV2 = Vue.resource(
  `${API_ROOT_V2}${participantManagement}${studies}/${participants}{/participantId}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const userDefinedparticipantResource = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}/${participants}{/participantId}/${userdefinedParticipantId}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);
const participantsSearchResource = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}/${participants}/${search}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);
const participantImportResource = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}/${participants}/${importcsv}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);
const participantExportResource = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}/${participants}/${exportcsv}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);
const participantDownloadTemplateResource = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}/${participants}/${downloadtemplate}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);
const participantsBatchInviteResource = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}/${participants}/${invite}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);
const participantsVerifyResource = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}/${participants}/${verify}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);
const participantForgotPasswordResource = Vue.resource(`${API_ROOT}${participantManagement}${participants}/${resetPassword}`);
const participantFilterResource = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}/${participants}/${sortparticipants}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);
const customlabelsResource = Vue.resource(`${API_ROOT}${participantManagement}${studies}/${participants}/${customlabels}`, {});
const customlabelResource = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}/${participants}/${customlabel}{/customId}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const documentsResource = Vue.resource(`${API_ROOT}${participantManagement}${studies}/${participants}{/participantId}/${documents}`);

const documentDetailsResource = Vue.resource(`${API_ROOT}${participantManagement}${studies}/${participants}{/participantId}/${documents}{/documentId}?inValidateDocumentId={inValidateDocumentId}&isInvalidate={isInvalidate}`);

const requestSignatureResource = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}/${participants}{/participantId}/${documents}{/docId}/${requestsignature}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const documentHistoryResource = Vue.resource(`${API_ROOT}${participantManagement}${studies}/${participants}{/participantId}/${documents}{/docId}/${eventhistory}`);

const requestPISignatureResource = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}/${participants}{/participantId}/${documents}{/docId}/${piesignature}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const sendMailResource = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}/${participants}{/participantId}/${documents}{/docId}/${maildocument}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const participantsVerifyV2Resource = Vue.resource(
  `${API_ROOT_V2}${participantManagement}${studies}/${participants}/${verify}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const participantsPaginationResource = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}/${participants}/${pagination}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const notInvitedParticipantsResource = Vue.resource(`${API_ROOT}${participantManagement}${studies}/${participants}/${notInvited}`, {});

const addParticipantListResource = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}/${participants}/${multi}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const notifyParticipantTeleCall = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}/${participants}/${pushnotification}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const getResetPasswordKeys = Vue.resource(
  `${API_ROOT}${participantManagement}${participants}/${resetPasswordContent}{/languageId}{/token}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const milestoneDetail = Vue.resource(
  `${API_ROOT}${responsemanagement}${participant}/${milestone}/${completed}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const participantDetail = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}{/studyId}/${participant}{/participantId}/${milestones}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);
const setDayZeroForParticipant = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}{/studyId}/${participants}{/participantId}/${start}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const participantManualStudyStartStatus = Vue.resource(`${API_ROOT}${participantManagement}${participants}/{participantId}/${start}/${status}`);

const getParticipantTaskInPagination = Vue.resource(
  `${API_ROOT}${queryTool}/${participant}{/pId}/${tasks}/${pagination}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const verificationResource = Vue.resource(
  `${API_ROOT_V2}${participantManagement}${studies}/${participants}{/participantId}/${resendVerify}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const unsubscribeResource = Vue.resource(
  `${API_ROOT_V3}${participantManagement}${participants}{/participantId}/${unsubscribeemail}`,
  { unsubscribeEmail: false },
  {
    update: {
      method: "PUT"
    }
  }
);

const getSiteTeamTaskInPagination = Vue.resource(
  `${API_ROOT}${edc}/${participant}{/pId}/${study}{/studyId}/${site}/${team}/${tasks}/${pagination}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const blindedVerifyResource = Vue.resource(`${API_ROOT}${studyManagement}${users}/${blinded}`);

const studyParticipantDocuementResource = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}{/studyId}/${sites}{/siteId}/${participant}{/participantId}/${document}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const sentMessagesResource = Vue.resource(`${API_ROOT}${participantManagement}${studies}/${participants}/${notifications}/${study}{/studyId}/${site}{/siteId}`, {});

const postMessagesResource = Vue.resource(`${API_ROOT}${participantManagement}${studies}/${participants}/${send}/${notification}`, {});

const notificationRecipientResource = Vue.resource(`${API_ROOT}${participantManagement}${studies}/${participants}/${notification}/${sent}/${participantlist}{/notificationId}`, {});
const SelectedParticipantsForSiteDocument = Vue.resource(`${API_ROOT_V2}${participantManagement}${studies}{/studyId}/document/activated/participantlist{/docId}`, {});
const participantTaskWithFilterResource = Vue.resource(
  `${API_ROOT_V2}${queryTool}/${participant}{/pId}/${tasks}/${pagination}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const edcTaskWithFilterResource = Vue.resource(
  `${API_ROOT_V2}${edc}/${participant}{/pId}/${study}{/studyId}/${site}/${team}/${tasks}/${pagination}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const postActivitesResource = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}/${participants}{/participantId}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);
const saveUserDefinedId = Vue.resource(`${API_ROOT_V2}${participantManagement}${studies}/${participants}/{/participantId}/${userdefinedParticipantId}`, {});

const saveNewEmail = Vue.resource(`${API_ROOT}${participantManagement}${studies}/${participants}/{participantId}/${email}`, {});

const requestConfiguredDocumentPISignatureResource = Vue.resource(
  `${API_ROOT_V3}${participantManagement}${studies}/${participants}{/participantId}/${documents}{/docId}/${piesignature}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const participantsSignoff = Vue.resource(
  `${API_ROOT}${edc}{/studyId}/${signoff}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const participantsSiteTransfer = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}/{studyId}/${participants}/${transfer}`,
  {},
  {
    save: {
      method: "POST"
    }
  }
);

const getParticipantsSiteTransferRequest = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}/{studyId}/${participants}{/participantId}/${transfer}`,
  {},
  {
    update: {
      method: "GET"
    }
  }
);

const getPendingTransferListRequest = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}/{studyId}/${participants}/${transfer}/{transferId}/${participantlist}`,
  {},
  {
    update: {
      method: "GET"
    }
  }
);

const acceptOrDeclineTransferRequest = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}/{studyId}/${participants}/${transfer}/{transferId}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const getJITActivityListResource = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}/{studyId}/${participants}{/participantId}/${demand}/${activity}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const sendJITActivitiesResource = Vue.resource(
  `${API_ROOT}${responsemanagement}${studies}/{studyId}/${participants}{/participantId}/${version}{/versionId}/${demand}/${activity}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const sendJITSiteActivitiesResource = Vue.resource(
  `${API_ROOT_V2}${edc}/${studies}/{studyId}/${participants}{/participantId}/${version}{/versionId}/${demand}/${activity}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const checkPreScreenedActivityResource = Vue.resource(
  `${API_ROOT}${responsemanagement}${studies}/{studyId}/${participants}{/participantId}/${prescreened}/${activity}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const sendPreScreenedActivityResource = Vue.resource(
  `${API_ROOT}${responsemanagement}${studies}/{studyId}/${participants}{/participantId}/${version}{/versionId}/${demand}/${prescreened}/${activity}{/languageId}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const getPreScreenedActivityResource = Vue.resource(
  `${API_ROOT}${responsemanagement}${studies}/{studyId}/${participants}{/participantId}/${demand}/${prescreened}/${activity}{/languageId}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const participantsVerifyV3Resource = Vue.resource(
  `${API_ROOT_V3}${participantManagement}${studies}/${participants}/${verify}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const getDeleteOnDemondActivity = Vue.resource(
  `${API_ROOT}${responsemanagement}${studies}/{studyId}/${demand}/${activity}/${"status"}/${"withdrawn"}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const postDeleteOnDemondActivity = Vue.resource(
  `${API_ROOT}${responsemanagement}${studies}/{studyId}/${demand}/${activity}/${"status"}/${"withdrawn"}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);
const getSiteFacingStatuses = Vue.resource(
  `${API_ROOT}${edc}/${studies}/{studyId}/${participants}/{participantId}/${statusKey}`,
  {},
  {
    update: { method: "GET" }
  }
);

const updateSiteFacingStatuses = Vue.resource(
  `${API_ROOT}${edc}/${studies}/{studyId}/${participants}/{participantId}/${statusKey}`,
  {},
  {
    update: { method: "PUT" }
  }
);

// Update status(Bulk) call for participant level
const toggleStatusesAtParticipantLevel = Vue.resource(
  `${API_ROOT_STUDY_RESPONSE}${studyResponse}${studies}/{studyId}/${participant}/{participantId}/${statusKey}`,
  {},
  {
    save: { method: "POST" }
  }
);

// Update Statuses(Bulk) at Milestone level
const toggleStatusesAtMilestoneLevel = Vue.resource(
  `${API_ROOT_STUDY_RESPONSE}${studyResponse}${studies}/{studyId}/${participant}/{participantId}/{milestoneId}/${statusKey}?milestoneDay={milestoneDay}`,
  {},
  {
    save: { method: "POST" }
  }
);
const documentDetailsPageWiseResource = Vue.resource(`${API_ROOT}${participantManagement}${studies}/${participants}{/participantId}/${documents}{/documentId}/pagination?studyId={studyId}&page={page}&inValidateDocumentId={inValidateDocumentId}&isInvalidate={isInvalidate}`);
const participantResendDoc = Vue.resource(
  `${API_ROOT}${participantManagement}${studies}{/studyId}/invalidatedocument/${participants}{/participantId}?docId={docId}&resendDocument={status}`,
  {},
  {
    save: {
      method: "POST"
    }
  }
);
const documentDetailStatusResource = Vue.resource(`${API_ROOT}${participantManagement}${studies}/${participants}{/participantId}/${documents}{/documentId}/status`);

//TUR-61129 start
const updateParticipantVerificationPhoneCognito = Vue.resource(
  `${COGNITO_API_US_WEB_ROOT}${participant}/${general}/${updateCognitoPhoneNumber}`,
  {},
  {
    save: {
      method: "POST"
    }
  }
);
//TUR-61129 end

const esignOrderStatusResource = Vue.resource(`${ESIGN_API_WEB_ROOT}${orderStatus}`);

export function participantTaks(studyId, pId, data, status, viewAllTask, isTelehealthEnabled, showTelehealthRecordings, showCompletedTasks) {
  const obj = {
    studyId: studyId,
    participantCurrentDay: data.participantCurrentDay,
    pId: pId,
    pageIndex: data.pageIndex,
    pageSize: data.pageSize,
    totalRecords: data.totalRecords,
    totalPage: data.totalPage,
    type: data.type,
    status: status,
    startDay: data.startDay,
    endDay: data.endDay,
    milestoneId: data.milestoneId,
    telehealth: isTelehealthEnabled,
    showCompletedTasks
  };
  // if study is having milestone or no milestone it willr efelct the same query param.
  if (viewAllTask) {
    obj.startDay = undefined;
    obj.endDay = undefined;
    obj.milestoneId = undefined;
  }
  if (showTelehealthRecordings) {
    obj.showTelehealthRecordings = showTelehealthRecordings;
    return participantTaskWithFilterResource.get(obj);
  }
  return getParticipantTaskInPagination.get(obj);
}

export function participantsMilestonsDetail(studyId, participantId, milestoneList, participantCurrentDay, status, isTelehealthEnabled, studyVersionId) {
  return milestoneDetail.save(
    {
      studyId,
      participantId,
      participantCurrentDay,
      status,
      telehealth: isTelehealthEnabled,
      studyVersionId
    },
    { participantMileStoneList: milestoneList.participantMileStoneList }
  );
}

export function participantEDCFormData(pId, startDay, endDay, studyId, data, status, viewAllTask, showTelehealthRecordings, showCompletedTasks) {
  const obj = {
    studyId: studyId,
    participantCurrentDay: data.participantCurrentDay,
    pId: pId,
    pageIndex: data.pageIndex,
    pageSize: data.pageSize,
    totalRecords: data.totalRecords,
    totalPage: data.totalPage,
    status: status,
    startDay: startDay,
    endDay: endDay,
    milestoneId: data.milestoneId,
    showCompletedTasks
  };
  if (viewAllTask) {
    obj.startDay = data.startDay;
    obj.endDay = data.endDay;
    obj.milestoneId = data.milestoneId;
  }
  if (status == "WITHDRAWSTUDY" || status == "DISQUALIFIED" || status == "DISCONTINUED") {
    obj.currentDay = data.currentDay;
  }
  if (showTelehealthRecordings) {
    obj.showTelehealthRecordings = showTelehealthRecordings;
    return edcTaskWithFilterResource.get(obj);
  }
  return getSiteTeamTaskInPagination.get(obj);
}
export function participantFullDetail(studyId, participantId, isTelehealthEnabled) {
  return participantDetail.get({
    studyId: studyId,
    participantId: participantId,
    telehealth: isTelehealthEnabled
  });
}

export function triggerParticipantDayZero(data) {
  return setDayZeroForParticipant.save({ participantId: data.participantId, studyId: data.studyId }, data);
}
export function resetPasswordKey(languageId, token) {
  return getResetPasswordKeys.get({ languageId, token });
}

export function getAllParticipantsFact(studyId) {
  return participantsResource.get({
    studyId
  });
}

export function participantSearchFilterFact(studyId, searchQuery, sort, filter) {
  return participantFilterResource.get({
    studyId,
    search: searchQuery,
    sort,
    filter
  });
}

export function getParticipantDataFact(studyId, participantId) {
  return participantsResource.get({
    studyId,
    participantId
  });
}

export function getParticipantDataFactV2(studyId, participantId) {
  return participantsResourceV2.get({
    studyId,
    participantId
  });
}

export function importParticipantDataFact(studyId, data) {
  return participantImportResource.save(
    {
      studyId
    },
    data
  );
}

export function exportParticipantDataFact(studyId) {
  return participantExportResource.get({
    studyId
  });
}
export function downloadTemplateParticipantDataFact(studyId, type) {
  return participantDownloadTemplateResource.get({
    studyId,
    type
  });
}

export function addNewParticipantInfoFact(studyId, data) {
  return participantsResource.save(
    {
      studyId
    },
    data
  );
}
export function updateParticipantInfoFact({ studyId, participantId, data, isWeb, isMobile, invite }) {
  return participantsResource.update(
    {
      studyId,
      participantId,
      isWeb,
      isMobile,
      invite
    },
    data
  );
}
export function updateParticipantIdFact({ studyId, participantId, isPhone, data }) {
  return userDefinedparticipantResource.update({ participantId, studyId, isPhone }, data);
}

export function batchInviteInfoFact(studyId, data) {
  return participantsBatchInviteResource.update(
    {
      studyId
    },
    data
  );
}

export function batchUnsubscribeResource(participantId) {
  return unsubscribeResource.update(
    {
      participantId
    },
    {}
  );
}

export function verifyParticipantDataFact(studyId, token, email) {
  return participantsVerifyResource.get({
    studyId,
    token,
    email
  });
}

export function verifyParticipantV2DataFact(qyerynPathParams) {
  return participantsVerifyV2Resource.get(qyerynPathParams);
}

export function searchParticipantsFact(studyId, searchTerm) {
  return participantsSearchResource.get({
    studyId,
    email: searchTerm
  });
}

export function participantForgotPasswordFact(data) {
  return participantForgotPasswordResource.save(data);
}

export function getLabelsFact(studyId) {
  return customlabelsResource.get({
    studyId
  });
}

export function addNewLabelFact(studyId, data) {
  return customlabelsResource.save(
    {
      studyId
    },
    data
  );
}

export function updateNewLabelFact(studyId, labelId, data) {
  return customlabelResource.update(
    {
      studyId,
      customId: labelId
    },
    data
  );
}

export function deleteNewLabelFact(studyId, labelId) {
  return customlabelResource.delete({
    studyId,
    customId: labelId
  });
}

export function addNewLabelValueFact({ studyId, participantId, data }) {
  return participantsResource.update(
    {
      studyId,
      participantId,
      key: data.key
    },
    data
  );
}

export function documentsListFact({ studyId, participantId }) {
  return documentsResource.get({
    studyId,
    participantId
  });
}

export function getDocumentDetailsFact({ studyId, participantId, documentId, inValidateDocumentId, isInvalidate }) {
  return documentDetailsResource.get({
    studyId,
    participantId,
    documentId,
    inValidateDocumentId,
    isInvalidate
  });
}

export function requestSignatureFact({ studyId, participantId, docId, reqSignDate, cancelRequest, resend }) {
  const params = {
    studyId,
    participantId,
    docId,
    reqSignDate
  };

  if (cancelRequest) {
    params["cancelRequest"] = cancelRequest;
  }
  if (resend) {
    params["resend"] = resend;
  }
  return requestSignatureResource.save(params, {});
}

export function documentHistoryFact({ studyId, participantId, docId, invalidatedDocument, inValidateDocumentId }) {
  return documentHistoryResource.get({
    studyId,
    participantId,
    docId,
    invalidatedDocument,
    inValidateDocumentId
  });
}

export function requestPISignatureFact({ studyId, participantId, docId, data }) {
  return requestPISignatureResource.save(
    {
      studyId,
      participantId,
      docId
    },
    data
  );
}

export function sendMailFact({ studyId, participantId, docId, data }) {
  return sendMailResource.save(
    {
      studyId,
      participantId,
      docId
    },
    data
  );
}

export function getParticipantsListFact(studyId, pageSize, pageNum, search, filter, sortValue, sortOrder, customKey, sourcefilter, cohortId, docId, languageId, activateForMoreParticipants, withdrawnOrFailedFilter, includeVerified = false, isTelehealthSearch = false, siteIds = "", countryIds = "") {
  return participantsPaginationResource.get({
    studyId,
    pageSize,
    pageNum,
    search,
    filter,
    sortValue,
    sortOrder,
    customKey,
    sourcefilter,
    cohortId,
    docId,
    languageId,
    activateForMoreParticipants,
    withdrawnOrFailedFilter,
    siteIds,
    includeVerified,
    isTelehealthSearch,
    countryIds
  });
}

export function getNotInvitedParticipantsFact(studyId) {
  return notInvitedParticipantsResource.get({
    studyId
  });
}

export function addParticipantListFact(studyId, sendInvite, data, isWeb, isMobile) {
  return addParticipantListResource.save(
    {
      studyId,
      sendInvite,
      isWeb,
      isMobile
    },
    data
  );
}

export function notifyParticipantForTelehealthCall(data) {
  return notifyParticipantTeleCall.save(
    {
      studyId: data.studyId,
      participantId: data.participantId,
      appointmentId: data.appointmentId,
      message: data.message
    },
    {}
  );
}

export function getBlindedRole() {
  return blindedVerifyResource.get();
}
export function resendVerificationFact({ studyId, participantId }) {
  return verificationResource.update(
    {
      studyId,
      participantId
    },
    {}
  );
}

export function saveStudyParticipantDocuement(studyId, siteId, participantId, formData) {
  return studyParticipantDocuementResource.save({ studyId, siteId, participantId }, formData);
}

export function getSentMessagesList(pathParams, queryParams) {
  return sentMessagesResource.get({ ...pathParams, ...queryParams });
}

export function sendMessagesToParticipants(queryParams, postData) {
  return postMessagesResource.save(queryParams, postData);
}

export function getNotificationRecipientList(pathParams, queryParams) {
  return notificationRecipientResource.get({ ...pathParams, ...queryParams });
}

export function getSelectedParticipantsForSiteDocumentList(pathParams, queryParams) {
  return SelectedParticipantsForSiteDocument.get({
    ...pathParams,
    ...queryParams
  });
}

export function postDisableActivitiesAndNotifications(studyId, participantId, data) {
  return postActivitesResource.update({ studyId, participantId }, data);
}

export function saveUserDefinedParticipantIdV2(data, studyId, participantId) {
  return saveUserDefinedId.update({ studyId, participantId }, data);
}

export function saveNewEmailId(data, participantId, isDuplicateAllowed) {
  return saveNewEmail.update({ participantId, isDuplicateAllowed }, data);
}

export function requestConfiguredPISignatureFact({ studyId, participantId, docId, requestObj, siteId }) {
  return requestConfiguredDocumentPISignatureResource.save(
    {
      studyId,
      participantId,
      docId,
      siteId
    },
    requestObj
  );
}

export function participantsSignoffResource(studyId, data) {
  return participantsSignoff.update({ studyId }, data);
}

export function getPendingTransferList(queryParams) {
  return getPendingTransferListRequest.get({
    studyId: queryParams.studyId,
    transferId: queryParams.transferId
  });
}

export function transferApproval(studyId, transferId, payload) {
  return acceptOrDeclineTransferRequest.update({ studyId, transferId }, { status: payload.status, reviewReason: payload.reviewReason });
}
export function participantsSiteTransferID(studyId, data) {
  return participantsSiteTransfer.save({ studyId }, data);
}
export function getSiteTransferData(queryParams) {
  return getParticipantsSiteTransferRequest.get({
    studyId: queryParams.studyId,
    participantId: queryParams.participantId
  });
}
export function getJITActivityListDataFact(queryParams) {
  return getJITActivityListResource.get({
    studyId: queryParams.studyId,
    participantId: queryParams.participantId,
    status: queryParams.status,
    telehealth: queryParams.telehealth,
    participantCurrentDay: queryParams.participantCurrentDay,
    sortOrder: queryParams.sortOrder,
    sortBy: queryParams.sortBy,
    pageIndex: queryParams.pageIndex,
    pageSize: queryParams.pageSize,
    preScreened: queryParams.preScreened
  });
}

export function sendJITActivities(queryParams, postData) {
  return sendJITActivitiesResource.update(queryParams, postData);
}

export function sendJITSiteActivities(queryParams, postData) {
  return sendJITSiteActivitiesResource.update(queryParams, postData);
}

export function getPreScreenedActivityCheck(studyId, participantId) {
  return checkPreScreenedActivityResource.get({ studyId, participantId });
}

export function sendPreScreenedActivity(queryParams, postData) {
  return sendPreScreenedActivityResource.update(queryParams, postData);
}

export function getPreScreenedActivityFact(queryParams) {
  return getPreScreenedActivityResource.get(queryParams);
}

export function verifyParticipantV3DataFact(qyerynPathParams) {
  return participantsVerifyV3Resource.get(qyerynPathParams);
}

export function getDeleteOnDemondActivityFact(studyId, studyVersionId, taskInstanceId, participantId) {
  return getDeleteOnDemondActivity.get({
    studyId,
    studyVersionId,
    taskInstanceId,
    participantId
  });
}

export function postDeleteOnDemondActivityFact(studyId, data) {
  return postDeleteOnDemondActivity.update({ studyId }, data);
}

export function getSiteFacingFormStatuses(studyId, participantId, data = {}) {
  return getSiteFacingStatuses.get({ studyId, participantId, ...data });
}

export function updateSiteFacingFormStatuses(studyId, participantId, status, data = {}) {
  return updateSiteFacingStatuses.update({ studyId, participantId, status, ...data }, {});
}

export function getParticipantFacingFormStatuses(studyId, participantId) {
  return toggleStatusesAtParticipantLevel.get({ studyId, participantId });
}

export function getParticipantFacingFormStatusesAtMilestone(studyId, participantId, milestoneId, milestoneDay) {
  return toggleStatusesAtMilestoneLevel.get({
    studyId,
    participantId,
    milestoneId,
    milestoneDay
  });
}

export function updateParticipantFacingFormStatuses(studyId, participantId, status, payload) {
  return toggleStatusesAtParticipantLevel.save({ studyId, participantId, status }, payload);
}

export function updateParticipantFacingFormStatusesAtMilestone(studyId, participantId, milestoneId, status, payload) {
  return toggleStatusesAtMilestoneLevel.save({ studyId, participantId, milestoneId, status }, payload);
}

export function participantResendDocument(queryParams, data) {
  return participantResendDoc.save(
    {
      studyId: queryParams.studyId,
      participantId: queryParams.participantId,
      docId: queryParams.docId,
      status: queryParams.status
    },
    data
  );
}
export function getParticipantManualStudyStartStatus(participantId, data) {
  return participantManualStudyStartStatus.get({ participantId, ...data });
}
export function getPageWiseDocumentDetailsFact({ studyId, participantId, documentId, inValidateDocumentId, isInvalidate, page }) {
  return documentDetailsPageWiseResource.get({
    studyId,
    participantId,
    documentId,
    inValidateDocumentId,
    isInvalidate,
    page
  });
}
export function getDocumentStatusDetailsFact({ studyId, participantId, documentId }) {
  return documentDetailStatusResource.get({
    studyId,
    participantId,
    documentId
  });
}

export function updateCognitoPhoneNo(payload) {
  return updateParticipantVerificationPhoneCognito.save({}, payload);
}

export function esignOrderStatus(data) {
  return esignOrderStatusResource.get(data);
}
